import { Box, Spinner, Text, VStack } from "@chakra-ui/react";

// full page loading component
// This component can be used to show a loading state for the entire page

function GlobalLoading() {
  return (
    <Box
      position={"fixed"}
      top={0}
      left={0}
      right={0}
      bottom={0}
      p={6}
      bg="gray.50"
      display="flex"
      justifyContent="center"
      alignItems="center"
      opacity={0.8}
      zIndex={9999}
    >
      <VStack>
        <Spinner
          color="blue.500"
          size={"xl"}
          borderWidth="4px"
          css={{ "--spinner-track-color": "colors.gray.200" }}
        />
        <Text>Loading...</Text>
      </VStack>
    </Box>
  );
}

export default GlobalLoading;
